import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Checklist — liste avec coches duotone */
export const ListChecksIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille check menthe (1ère ligne) */}
      <circle cx="5" cy="6" r="2.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M3.8 6l1 1 1.5-1.75"
        stroke="hsl(var(--background))" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Pastille check menthe (2ème ligne) */}
      <circle cx="5" cy="12" r="2.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M3.8 12l1 1 1.5-1.75"
        stroke="hsl(var(--background))" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Puce vide 3ème ligne */}
      <circle cx="5" cy="18" r="2.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Lignes texte */}
      <path
        d="M10 6h11M10 12h11M10 18h8"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
ListChecksIcon.displayName = "ListChecksIcon";
